import React from 'react';
import { GlbEngravingInsoleView } from './GlbEngravingInsoleView';
import { ContactShadows, Environment } from '@react-three/drei';
import { RibbingView } from './RibbingView';
import { getInsoleGlb, getRibbingGlb } from '../../../constants/glb-assets';
import { FoamPackageType, FOAM_PACKAGE_TYPES } from '../../../constants/foot';
import studioHdr from '../../../assets/react-three-enviorment/studio_small_03_1k.hdr';
import { sceneTunnel } from '../../insole-studio/sceneTunnel';
import { CameraSetter } from '../../insole-studio/CameraSetter';

interface EngravingSceneProps {
	foamPackageType: FoamPackageType;
	leftTextRef: React.MutableRefObject<string>;
	rightTextRef: React.MutableRefObject<string>;
	engravingInsoleMeshNames: { left: string, right: string };
	ribbingLevel: number;
}

// This component no longer owns a <Canvas>. It portals its R3F scene content
// into the single PersistentCanvas via sceneTunnel.In so that switching
// routes does not destroy & recreate the WebGL context (the cause of the iOS
// Safari crashes after a few back/next toggles).
const EngravingScene = ({
	foamPackageType = FOAM_PACKAGE_TYPES.SUPERREV,
	leftTextRef,
	rightTextRef,
	engravingInsoleMeshNames,
	ribbingLevel = 0,
}: EngravingSceneProps) => {
	return (
		<sceneTunnel.In>
			<CameraSetter
				near={0.001}
				far={1}
				fov={45}
				position={[0, -0.001, 0.027]}
				lookAt={[0, 0, 0]}
			/>
			<ambientLight intensity={0.7} />
			<Environment files={studioHdr} environmentIntensity={0.5} />
			<ContactShadows position={[0, -0.003, 0]} scale={0.05} opacity={0.6} blur={1} far={0.01} />

			<GlbEngravingInsoleView
				insoleUri={getInsoleGlb(foamPackageType, 'LeftFoot')}
				textRef={leftTextRef}
				isLeft
				engravingInsoleMeshName={engravingInsoleMeshNames.left}
			/>
			<RibbingView
				lightUri={getRibbingGlb('left', 'light')}
				heavyUri={getRibbingGlb('left', 'heavy')}
				ribbingLevel={ribbingLevel}
				isLeft
			/>

			<GlbEngravingInsoleView
				insoleUri={getInsoleGlb(foamPackageType, 'RightFoot')}
				textRef={rightTextRef}
				isLeft={false}
				engravingInsoleMeshName={engravingInsoleMeshNames.right}
			/>
			<RibbingView
				lightUri={getRibbingGlb('right', 'light')}
				heavyUri={getRibbingGlb('right', 'heavy')}
				ribbingLevel={ribbingLevel}
				isLeft={false}
			/>
		</sceneTunnel.In>
	);
};

export default EngravingScene;
